import { render, staticRenderFns } from "./AuthCheck.vue?vue&type=template&id=1803c1a0&scoped=true&"
import script from "./AuthCheck.vue?vue&type=script&lang=ts&"
export * from "./AuthCheck.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1803c1a0",
  null
  
)

export default component.exports